import { render } from "./LegacyZoneIntervalSelection.vue?vue&type=template&id=cb4c35ec"
import script from "./LegacyZoneIntervalSelection.vue?vue&type=script&lang=js"
export * from "./LegacyZoneIntervalSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__